import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { BiometricConsentRequest } from 'src/app/core/dtos/dto';
import { StorageHelper } from 'src/app/core/services/helpers/storage.helper';
import { RegistrationService } from 'src/app/core/services/registration.service';
import { selectMyAccount } from 'src/app/state/my-account.selectors';

@Component({
  selector: 'app-biometric-consent-form',
  templateUrl: './biometric-consent-form.component.html',
  styleUrls: ['./biometric-consent-form.component.scss']
})
export class BiometricConsentFormComponent implements OnInit, OnDestroy {

  @Output() setBiometricConsent: EventEmitter<BiometricConsentRequest> = new EventEmitter();
  @Input() isRegFlow: boolean;

  isBiometricConsent = false;
  upcomingRegId: number;
  serviceTerm: string;
  getConsentSubscription: Subscription;
  upcomingRegSubscription: Subscription;

  constructor(
    private registrationService: RegistrationService,
    private toastService: HotToastService,
    private storageHelper: StorageHelper,
    private store: Store
  ) {
  }

  ngOnInit(): void {
    this.upcomingRegId = this.isRegFlow ? 0 : this.getUpcomingRegId();
    this.getBiometricConsent(this.upcomingRegId);
  }

  getUpcomingRegId(): number {
    let regId;
    this.upcomingRegSubscription = this.store.pipe(select(selectMyAccount))
      .subscribe(result => {
        regId = result?.upcomingRegistration?.regId;
      });
    if (!regId) {
      regId = JSON.parse(this.storageHelper.loadFromSessionStorage("upcomingRegistration"))?.regId;
    }
    return regId;
  }

  getBiometricConsent(regId: number) {
    this.getConsentSubscription = this.registrationService.getBiometricConsent(regId)
      .subscribe(
        result => {
          //remove  inline styling from serviceTerm
          this.serviceTerm = (result.content.serviceTerm).replace(new RegExp('style="(.*?)"', 'g'), "");
        },
        () => this.toastService.warning("Failed to load biometric consent.")
      );
  }

  goNext() {
    const biometricConsentRequest: BiometricConsentRequest = {
      isBiometricConsent: this.isBiometricConsent,
      upcomingRegId: this.upcomingRegId
    };
    this.setBiometricConsent.emit(biometricConsentRequest);
  }

  ngOnDestroy() {
    this.getConsentSubscription?.unsubscribe();
    this.upcomingRegSubscription?.unsubscribe();
  }

}
